import axiosInstance from "../axiosInstance";
import { currentBaseURL, URL_GET_COMPLIANCE_FORM } from "../endpoints";

const getComplianceFormStatus = async () => {
  try {
    const response = await axiosInstance.get(`${currentBaseURL}/${URL_GET_COMPLIANCE_FORM}`);
    // console.log(response);
    return response;
  } catch (e) {
    throw e;
  }
};

const complianceFormSubmit = async ({
  tenant_id,
  company_legal_name,
  website_url,
  address,
  city,
  country,
  zipcode,
  app_name,
  app_url,
  privacy_policy_url,
  app_description,
  phyllo_usage_text,
  is_meeting_booked,
}) => {
  try {
    const response = await axiosInstance.post(`${currentBaseURL}/${URL_GET_COMPLIANCE_FORM}`, {
      tenant_id,
      company_legal_name,
      website_url,
      address,
      city,
      country,
      zipcode,
      app_name,
      app_url,
      privacy_policy_url,
      app_description,
      phyllo_usage_text,
      is_meeting_booked,
    });
    return response;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export { getComplianceFormStatus, complianceFormSubmit };
